import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from '../../node_modules/ngx-bootstrap';
import { AuthService } from '@app/core/services';
import { MessagingService } from '@app/core/services/messaging.service';


@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  title = 'sa';
  @ViewChild('myModal') public myModal:ModalDirective;
  
  constructor(public msg: MessagingService, public auth: AuthService){
    localStorage.setItem('sm-fixed-header', "true");
  }

  ngOnInit() { 

    this.auth.getCurrentUser().then(user => {
      if(user){
        this.msg.getPermission(user)
        this.msg.monitorRefresh(user)
        this.msg.receiveMessages()
      }
    });
    
  }
}
